/*
Description : Generate a list from the data received

Parameters :
  Column : Array of object to detail each Column to display
    Column : [
      {
        label: string => Label to display in the column header
        property: string => Name of the property for the values of the column
        style: object => Style (use style format) for the column
        isMobile: boolean => Should it display if mobile 
      }
    ] 
  Data : Array of object with the value of each record to display. Property of the object have to exists in the columns properties.
    Data: [
      {
        <property> : <value>
      }
    ]
  Sort : Object with property name and direction for sorting
    Sort: {
      property: string => name of the property sorted
      direction: number => 1 = descending, 2 = ascending
    }
  OnClickSort : Function called when clicking on sort
    OnClickSort : function
  OnClickItem : Function called when clicking on item
    OnClickItem : function   
  Debug: If Debug mode
    Debug: Boolean => enable or not
  ListStyle : Style of List container
    ListStyle: style object
  HeaderStyle : Style of header container
    HeaderStyle: style object
  BodyStyle : Style of body container
    BodyStyle: style object
  BodyRowStyle : Style of body row container
    BodyRowStyle: style object
*/
import _ from "lodash";

import { TiArrowUnsorted, TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import LoadingComponent from "./LoadingComponent";
import { getLabel } from "../../tools/Dictionary";

import "./ListComponent.css";
import { Fragment } from "react";


const ListComponent = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const Column = props.Column;
  const Data = props.Data;
  const Sort = props.Sort;
  const OnClickSort = props.OnClickSort;
  const OnClickItem = props.OnClickItem;
  const ListStyle = props.ListStyle;
  const HeaderStyle = props.HeaderStyle;
  const BodyStyle = props.BodyStyle;
  const BodyRowStyle = props.BodyRowStyle;
  const Debug = props.Debug;
  const Loading = props.Loading;
  const ShowLoading = props.ShowLoading;
  const Selected = props.Selected;



  //Debug display
  if (Debug){

    let sum = 0;

    Column.forEach(c => {
      if (c.style && c.style.width && c.style.width.includes("%")){
        sum += parseInt(c.style.width.replace(/%/g, ''));
      }
    });

    console.log("List Component Debug Mode")
    console.log(`Total width coverage of the column : ${sum}%`);

  }
  //Debug end

  const onClickSort = (_property) =>
  {


    //Change Sort value
    let sort = _.clone(Sort);

    if (sort.property != _property)
    {

      sort.property = _property;
      sort.direction = -1;

    } else
      sort.direction = sort.direction == 1 ? -1 : 1;

    OnClickSort(sort);

  }

  

  const displaySortIcon = (_property) => {

    if (!onClickSort) return null;

    if (_property == Sort.property){
      if (Sort.direction == -1) 
        return (
          <div className="listcomponent_header_col_icon" style={{color: "black"}}>
            <TiArrowSortedDown />
          </div>
        );
      else
        return (
          <div className="listcomponent_header_col_icon" style={{ color: "black" }}>
            <TiArrowSortedUp />
          </div>
        );
    }

    return (
      <div className="listcomponent_header_col_icon">
        <TiArrowUnsorted />
      </div>
    );

  };
  


  const displayValue = (_data, _column) => {

    let value = "";


    try
    {

      //Split value if . found
      let splittedProperty = _column.property.split(".");

      splittedProperty.forEach((p, index) => {
        value = index == 0 ? _data[p] : value[p];
      });

      switch (_column.format) {
        case "boolean":
          value = value ? getLabel("App", "Yes") : getLabel("App", "No");
          break;   
        default:
          break;
      }

      if (_column.isEmpty && (!value || value == "") && value != 0)
        value = _column.isEmpty;


      return value;

    }catch(err){

      return _column.isEmpty || "";   

    }
  };

  const displaySpecial = (d, c) => {

    if (c.isAction) {

      return (
        <div className="listcomponent_button_cont">
          {c.button.map((b, indexB) => (
            <Fragment key={indexB}>
              {b.isButton ? (
                <div className="listcomponent_button" style={b.style} onClick={(e) => { e.stopPropagation(); b.onClick(d); }} title={b.title}>
                  {b.icon}
                </div>
              ):(
                <div className="listcomponent_body_row_text" >
                  {b.label}
                </div>
              )}

            </Fragment>
          ))}
        </div>
      );
    }

    if (c.isMulti){

      const currentlySelected = Selected.find(s => s._id === d._id) ? true : false;

      let findButton = null;
      if (currentlySelected) {
        findButton = c.button.find(b => b.isSelected);
      }else {
        findButton = c.button.find(b => !b.isSelected);
      }


       return (
        <div className="listcomponent_button_cont">
          <div className="listcomponent_button" style={findButton.style} onClick={(e) => { e.stopPropagation(); findButton.onClick(d, Selected); }} title={findButton.title}>
            {findButton.icon}
          </div>
        </div>
       );

    }


    return null;

  }

  

  return (
    <div className="listcomponent_cont" style={ListStyle}> 
      <LoadingComponent
        display={Loading && ShowLoading}
        isCover={true}
        label={getLabel("App", "Loading")}
      />
      <div className="listcomponent_header_cont_parent">
        <div className="listcomponent_header_cont listcomponent_noselect" style={{ ...HeaderStyle, width: "100%" }}>
          {Column.filter(c => IsDesktop || (c.isMobile)).map((c, index) => (
            <div className={"listcomponent_header_col " + (OnClickSort ? "listcomponent_header_col_clickable" : "")} 
              key={index} 
              title={c.label} 
              style={IsDesktop ? c.style : c.mobileStyle}
              onClick={(OnClickSort && !Loading && !c.noFilter) ? () => onClickSort(c.property) : undefined}>
              <div className="listcomponent_header_col_text">
                {c.label}
              </div>
              {!c.noFilter && displaySortIcon(c.property)}
            </div>
          ))}
        </div>
      </div>
      <div className="listcomponent_body_cont" style={{ ...BodyStyle, width: "100%" }}>
        {Data.map((d, index) => (
          <Fragment key={index} >
              <div className="listcomponent_body_row_cont" style={{ backgroundColor: (index % 2 == 0 ? "white" : "#f2f2f2")}}>
                <div className={"listcomponent_body_row " + (OnClickItem ? "listcomponent_body_row_clickable" : "")}
                  style={{ ...d.style, ...BodyRowStyle}}
                  onClick={(OnClickItem) ? () => OnClickItem(d) : undefined}
                >
                  {Column.filter(c => IsDesktop || (c.isMobile)).map((c, indexC) => (
                    <div className="listcomponent_body_col"
                      key={indexC}
                      title={c.label}
                      style={IsDesktop ? c.style : c.mobileStyle}
                    >
                      {(c.isAction || c.isMulti) ? (
                        <Fragment>
                          { displaySpecial(d, c) }
                        </Fragment>
                      ):(
                      <div className = "listcomponent_body_row_text">
                        { displayValue(d, c) }
                      </div>                      
                      )}

                    </div>
                  ))}
                </div>
              {/* {Selectable &&
                <div className="listcomponent_select_button" onClick={() => OnClickSelect(d)}>
                    {getLabel("App", "Select")}
                  </div>
                } */}
              </div>
          </Fragment>
        ))}
      </div>
    </div>
  )
};

export default ListComponent;